<template>
  <div>
    <div
      :class="['stake-row py-4', { 'has-divider': index > 0 }]"
      v-for="(dataItem, index) in stakeItems"
      :key="dataItem.type + dataItem.token"
    >
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6"
      >
        <span class="gray--text">Asset</span>
        <div class="d-flex align-center text-uppercase">
          <span>{{ dataItem.token }}</span>
          <img
            :src="dataItem.icon"
            alt=""
            height="16"
            width="16"
            class="ml-2"
          />
        </div>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Total Staked AUM</span>
        <span>${{ dataItem.totalStakedAUM | numberFormat("0,0.00") }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Total Rewards Earned</span>
        <span v-if="!rewardsAutocompounded[dataItem.token]">
          ${{ dataItem.rewards | numberFormat("0,0.00") }}
        </span>
        <span v-else class="gray--text text-6">
          Rewards are <br />
          auto-compounded
        </span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Total Unbonding</span>
        <span v-if="dataItem.market.name === 'Tendermint'">
          ${{ dataItem.unbonding | numberFormat("0,0.00") }}
        </span>
        <span v-else class="gray--text text-6">{{ "N/A" }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Ecosystem</span>
        <div class="d-flex align-center">
          <span>{{ dataItem.market.name }}</span>
          <img
            class="ml-2"
            :src="dataItem.market.logo"
            height="16"
            width="16"
            :alt="dataItem.market.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stakeItems: Array,
  },
  data: () => ({
    rewardsAutocompounded: {
      knc: true,
      grt: true,
    },
  }),
};
</script>

<style lang="scss" scoped>
.stake-row {
  &.has-divider {
    border-top: 1px solid #e9ebff;
  }
}
</style>
